/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { defineMessages } from 'react-intl';
export default defineMessages({
  error400: {
    id: 'ErrorBoundary_error400',
    defaultMessage: 'Something went wrong. Try again later.'
  },
  error403: {
    id: 'ErrorBoundary_error403',
    defaultMessage: 'You cannot view this content {homePageLink}'
  },
  defaultError: {
    id: 'ErrorBoundary_defaultError',
    defaultMessage: 'Something went wrong. {refreshPageLink} or {goToHome}.'
  },
  networkError: {
    id: 'ErrorBoundary_networkError',
    defaultMessage: 'There was a problem getting information you requested. Check your network connection and {refreshPageLink} or {goToHome}.'
  },
  timeoutError: {
    id: 'ErrorBoundary_timeoutError',
    defaultMessage: 'A server timeout has occurred for this page. Check your network connection for connectivity and then {refreshPageLink}'
  },
  refreshPageLink: {
    id: 'ErrorBoundary_refreshPageLink',
    defaultMessage: 'Try again'
  },
  errorRedirectHomeLink: {
    id: 'ErrorBoundary_errorRedirectHomeLink',
    defaultMessage: 'go to home'
  },
  refreshPageLinkLowerCase: {
    id: 'ErrorBoundary_refreshPageLinkLowerCase',
    defaultMessage: 'try again'
  }
});